/* Pure signup helpers. Pricing-band selection is not a medicine dose recommendation. */
(function (root) {
  'use strict';
  function parseBand(title) {
    const match = String(title).match(/(\d+(?:\.\d+)?)\s*(?:-\s*(\d+(?:\.\d+)?)|\+)/);
    return match ? { min: Number(match[1]), max: match[2] ? Number(match[2]) : Infinity } : null;
  }
  function selectWeightVariant(raw, variants) {
    const text = String(raw).trim();
    if (!/^\d+(?:\.\d)?$/.test(text) || Number(text) <= 0) {
      return { error: 'Enter a current weight in kg, using no more than one decimal place.' };
    }
    const weight = Number(text);
    const matches = variants.filter(variant => {
      const band = parseBand(variant.title);
      return band && weight >= band.min && weight <= band.max;
    });
    if (matches.length !== 1) return { error: 'This weight needs a team review before selecting a subscription.' };
    if (matches[0].available === false) return { error: 'The matching subscription is currently unavailable.' };
    return { variant: matches[0], weight };
  }
  function normalizeAge(raw, unit) {
    const text = String(raw).trim();
    if (!/^\d+$/.test(text) || Number(text) < 1 || !['months', 'years'].includes(unit)) {
      return { error: 'Enter a positive whole number, then choose months or years.' };
    }
    const count = Number(text);
    if (!Number.isSafeInteger(count)) return { error: 'Please check your pet’s age.' };
    return { display: count + ' ' + (count === 1 ? unit.slice(0, -1) : unit), months: unit === 'years' ? count * 12 : count };
  }
  function normalizeBirthday(dateString, nowDate = new Date()) {
    const invalid = { error: 'Enter a valid birthday.' };
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(dateString));
    if (!match || !(nowDate instanceof Date) || !Number.isFinite(nowDate.getTime())) return invalid;
    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    // Use calendar components, not parsing YYYY-MM-DD as a UTC instant.
    // UTC is used only as a day counter so daylight-saving changes cannot
    // turn 56 calendar days into 55 days (or the reverse).
    function calendarDay(y, m, d) {
      const value = new Date(0);
      value.setUTCFullYear(y, m - 1, d);
      return value;
    }
    const birthday = calendarDay(year, month, day);
    if (year < 1 || birthday.getUTCFullYear() !== year ||
        birthday.getUTCMonth() !== month - 1 || birthday.getUTCDate() !== day) return invalid;
    const todayYear = nowDate.getFullYear();
    const todayMonth = nowDate.getMonth() + 1;
    const todayDay = nowDate.getDate();
    const ageDays = (calendarDay(todayYear, todayMonth, todayDay) - birthday) / 86400000;
    if (ageDays < 0) return { error: 'Birthday cannot be in the future.' };
    // A month is complete when its day-of-month anniversary is reached.
    const months = (todayYear - year) * 12 + todayMonth - month - (todayDay < day ? 1 : 0);
    const useYears = months > 0 && months % 12 === 0;
    const count = useYears ? months / 12 : months;
    const unit = useYears ? 'year' : 'month';
    return { months, display: count + ' ' + unit + (count === 1 ? '' : 's'), ageDays };
  }
  const api = { parseBand, selectWeightVariant, normalizeAge, normalizeBirthday };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.PLCSignupRules = api;
})(typeof window !== 'undefined' ? window : globalThis);
